module.exports = __webpack_public_path__ + "static/img/LX.39f1654a.png";